export default __webpack_public_path__ + "meetingRoomParticipants1.json";